import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Products } from "@/components/landing/Products";
import { About } from "@/components/landing/About";
import { WhyChoose } from "@/components/landing/WhyChoose";
import { Applications } from "@/components/landing/Applications";
import { BulkSupply } from "@/components/landing/BulkSupply";
import { DownloadApp } from "@/components/landing/DownloadApp";
import { Quotation } from "@/components/landing/Quotation";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="noise-layer" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <About />
        <WhyChoose />
        <Applications />
        <BulkSupply />
        <DownloadApp />
        <Quotation />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
